<template>
    <span
        v-if="flagEmoji"
        :aria-hidden="decorative ? 'true' : undefined"
        :aria-label="decorative ? undefined : ariaLabel"
        :role="decorative ? undefined : 'img'"
        class="flag"
    >
        {{ flagEmoji }}
    </span>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { countryFlagEmoji } from '@/components/app/locale/country-flag-emoji'
import type { CountryCode } from '@/graphql/api'

interface Props {
    country: CountryCode
    decorative?: boolean
    label?: string
}

const { country, decorative = true, label = undefined } = defineProps<Props>()

const flagEmoji = computed((): string => {
    return countryFlagEmoji(country)
})

const ariaLabel = computed((): string => label ?? `Flag of ${country}`)
</script>
